import { FC } from 'react';
import NextLink from 'next/link';
import { Box } from '@zoopla-eng/zds-components/box';
import { ArrowRightSmall } from '@zoopla-eng/zds-components/icons';
import { Link } from '@zoopla-eng/zds-components/link';
import { Grid } from '@zoopla-eng/zds-components/grid';
import { styled } from '@zoopla-eng/zds-components/themes';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';

const links = [
    {
        text: 'House prices in the UK',
        url: '/house-prices/uk/'
    },
    {
        text: 'House prices in England',
        url: '/house-prices/england/'
    },
    {
        text: 'House prices in Scotland',
        url: '/house-prices/scotland/'
    },
    {
        text: 'House prices in Northern Ireland',
        url: '/house-prices/northern-ireland/'
    },
    {
        text: 'House prices in London',
        url: '/house-prices/london/'
    },
    {
        text: 'House prices in Edinburgh',
        url: '/house-prices/edinburgh/'
    },
    {
        text: 'House prices in Glasgow',
        url: '/house-prices/glasgow/'
    },
    {
        text: 'House prices in Bristol',
        url: '/house-prices/bristol/'
    },
    {
        text: 'House prices in Birmingham',
        url: '/house-prices/birmingham/'
    },
    {
        text: 'House prices in Aberdeen',
        url: '/house-prices/aberdeen/'
    },
    {
        text: 'House prices in Manchester',
        url: '/house-prices/manchester/'
    },
    {
        text: 'House prices in Leeds',
        url: '/house-prices/west-yorkshire/leeds/'
    },
    {
        text: 'House prices in Sheffield',
        url: '/house-prices/sheffield/'
    },
    {
        text: 'House prices in Cambridge',
        url: '/house-prices/cambridgeshire/cambridge/'
    },
    {
        text: 'House prices in Nottingham',
        url: '/house-prices/nottingham/'
    },
    {
        text: 'House prices in Liverpool',
        url: '/house-prices/liverpool/'
    },
    {
        text: 'House prices in Coventry',
        url: '/house-prices/coventry/'
    },
    {
        text: 'House prices in Plymouth',
        url: '/house-prices/plymouth/'
    },
    {
        text: 'House prices in Cardiff',
        url: '/house-prices/cardiff/'
    },
    {
        text: 'House prices in Brighton',
        url: '/house-prices/east-sussex/brighton/'
    }
];

const Pictogram = styled('img', {
    height: '$L400',
    width: '$L400'
});

type Links = {
    text: string;
    url: string;
}[];

const LinkList: FC<{ links: Links }> = ({ links }) => (
    <Box as="ul" display="flex" flexFlow="column" rowGap="$S400">
        {links.map((l) => (
            <Box
                key={l.url}
                as="li"
                display="flex"
                alignItems="center"
                columnGap="$S400"
            >
                <ArrowRightSmall />
                <NextLink href={l.url} key={l.text} passHref>
                    <Link muted>{l.text}</Link>
                </NextLink>
            </Box>
        ))}
    </Box>
);

const SeoSearchLinks = ({
    linksPerColumn = 4
}: {
    linksPerColumn?: number;
}) => (
    <>
        <Box display="flex" alignItems="center" columnGap="$S400" pb="$S500">
            <Box>
                <Pictogram
                    src="//images.ctfassets.net/02vwvgr6spsr/5r97u52kEDKLjobpD2AOzq/02b688462b1d9fa7fd86f5b9fe357169/seo-search-links-placeholder.svg"
                    alt="city outline"
                />
            </Box>
            <PageSubtitleShort>
                Popular locations for house prices
            </PageSubtitleShort>
        </Box>
        <Box pl="calc($sizes$L400 + $S400)">
            <Grid
                gridRowGap="$S400"
                bpM100={{
                    gridTemplateColumns: 'auto auto',
                    gridColumnGap: '$M200'
                }}
            >
                <LinkList links={links.slice(0, linksPerColumn)} />
                <LinkList links={links.slice(linksPerColumn)} />
            </Grid>
        </Box>
    </>
);

export default SeoSearchLinks;
